"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSocketDisconnection = exports.handleSocketConnection = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var SocketActions = require("@caddigital/sok-reducers/lib/actions/socket");
var loginActionTypes = require("@caddigital/sok-reducers/lib/actionTypes/auth/login");
var currentActionTypes = require("@caddigital/sok-reducers/lib/actionTypes/auth/current");
function joinLobbyChannel() {
    return JSON.stringify({
        topic: "user:lobby",
        event: 'phx_join',
        payload: '',
        ref: ''
    });
}
function joinUserChannel(userUUID) {
    return JSON.stringify({
        topic: "user:".concat(userUUID),
        event: 'phx_join',
        payload: '',
        ref: ''
    });
}
function sendHeartbeat() {
    return JSON.stringify({
        topic: 'phoenix',
        event: 'heartbeat',
        payload: {},
        ref: 0
    });
}
var socket;
var reconnect = false;
var heartbeat;
function connect(observer, store) {
    var auth = store.value.auth;
    if (!socket && __SOCKET_HOST__ && __SOCKET_HOST__.length > 0) {
        socket = new WebSocket("".concat(__SOCKET_HOST__, "/websocket?token=").concat(auth.current.token));
        reconnect = true;
        socket.onopen = function () {
            if (socket) {
                socket.send(joinLobbyChannel());
                socket.send(joinUserChannel(auth.current.user.map(function (_a) {
                    var uuid = _a.uuid;
                    return uuid;
                }).getOrElse('uuid-missing')));
                heartbeat = setInterval(function () { return socket && socket.send(sendHeartbeat()); }, 30000);
            }
        };
        socket.onmessage = function (event) {
            if (event.data && event.data !== '') {
                try {
                    var data = JSON.parse(event.data);
                    if (data.event === 'phx_reply') {
                        return;
                    }
                    observer.next(SocketActions.socketIncomingCommandAction({
                        event: data.event,
                        message: data.payload.message
                    }));
                }
                catch (error) {
                    console.error('Invalid parse data', error);
                }
            }
        };
        socket.onerror = function () {
            if (reconnect) {
                socket && socket.close();
                socket = undefined;
                heartbeat && clearInterval(heartbeat);
                setTimeout(function () { return connect(observer, store); }, 2000);
            }
        };
        socket.onclose = function () {
            if (reconnect) {
                socket = undefined;
                heartbeat && clearInterval(heartbeat);
                setTimeout(function () { return connect(observer, store); }, 2000);
            }
        };
    }
}
var handleSocketConnection = function (action$, store) {
    return action$.pipe((0, operators_1.filter)(function (action) {
        return action.type === currentActionTypes.GET_USERINFO_SUCCESS &&
            !(socket &&
                (socket.readyState === socket.OPEN ||
                    socket.readyState === socket.CONNECTING));
    }), (0, operators_1.switchMap)(function () {
        return rxjs_1.Observable.create(function (observer) {
            connect(observer, store);
        });
    }));
};
exports.handleSocketConnection = handleSocketConnection;
var handleSocketDisconnection = function (action$) {
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === loginActionTypes.LOGOUT; }), (0, operators_1.mergeMap)(function () {
        reconnect = false;
        if (socket) {
            socket.close && socket.close(1000, 'logout');
            socket = undefined;
        }
        return (0, rxjs_1.empty)();
    }));
};
exports.handleSocketDisconnection = handleSocketDisconnection;
